import React, { FC } from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

import { Longdash } from '~/utils';
import { ResponseType } from '~/api/axios';
import { useApi } from '~/hooks';

interface ReferenceFieldProps<T> {
  selector: (record: T) => any;
  query: () => ResponseType<T>;
  className?: string;
  deps?: any[];
}

// eslint-disable-next-line func-names
const ReferenceField: FC<ReferenceFieldProps<any>> = function <T>(props: ReferenceFieldProps<T>) {
  const { selector, query, deps, className } = props;
  const [{ data, loading }] = useApi<T>(query, deps);
  const result = data && selector(data);

  if (loading) return <Skeleton.Button className={className} size="small" active />;
  return <div>{result || Longdash}</div>;
};

export default styled(ReferenceField)`
  height: 16px !important;
  max-width: 150px;
  display: flex;
  flex-grow: 1;
`;
